<template>
    <flex-container class="relative" :justify="justify" :align="align">
        <span :style="mainPriceStyles" :class="titleClass">&nbsp;{{ price }}</span>

        <flex-container
            v-if="showConverted && priceConverted"
            align="baseline"
            class="summary-converted-container"
            :class="{
                absolute: absoluteConvertedContainer,
                'relative-converted': !absoluteConvertedContainer
            }"
        >
            <p class="summary-converted-price" :style="{ fontSize: `${convertedFontSize}px` }">
                &nbsp;~{{ priceConverted }}
            </p>

            <TooltipWithQuestionMark
                :isTooltipBlue="true"
                :absolute="false"
                :tooltipTitle="`${getTooltipTitle()}`"
                :tooltipText="`${getTooltipText()}`"
                :style="{ left: `3px` }"
                :isButtonSlotExists="true"
                :defaultButtonStyles="false"
                :stopPropagation="true"
                :positionClasses="tooltipPosition"
            >
                <template v-slot:button>
                    <span :style="{ fontSize: `${convertedFontSize}px` }">[ ? ]</span>
                </template>
            </TooltipWithQuestionMark>
        </flex-container>
    </flex-container>
</template>

<script>
export default {
    name: "PriceWithConverted",
    components: {
        TooltipWithQuestionMark: () => import("@components/Tooltips/TooltipWithQuestionMark"),
        FlexContainer: () => import("@components/Containers/FlexContainer")
    },
    props: {
        showConverted: {
            type: Boolean,
            default: true
        },
        price: {
            type: String,
            required: true
        },
        priceConverted: {
            type: String,
            required: false
        },
        absoluteConvertedContainer: {
            type: Boolean,
            default: true
        },
        justify: {
            type: String,
            default: "flex-start"
        },
        align: {
            type: String,
            default: "flex-start"
        },
        titleClass: String,
        mainPriceWeight: [Number, String],
        mainPriceColor: String,
        tooltipPosition: {
            type: String,
            default: "bottom-left"
        },
        convertedFontSize: {
            type: Number,
            default: 12
        },
        defaultCurrency: String
    },
    data: () => ({
        locale: null
    }),
    computed: {
        mainPriceStyles() {
            return {
                fontWeight: this.mainPriceWeight && `${this.mainPriceWeight}`,
                color: this.mainPriceColor && this.mainPriceColor
            }
        }
    },
    created() {
        this.locale = window.app_current_locale
    },
    methods: {
        getTooltipTitle() {
            if (this.t) {
                return this.t("payments.price")
            }
            switch (this.locale) {
                case "uk":
                    return "Ціна"
                case "ru":
                    return "Цена"
                case "fr":
                    return "Coût"
                default:
                    return "Price"
            }
        },
        getTooltipText() {
            if (this.t) {
                return this.t("payments.currency_tooltip_text", { currency: this.defaultCurrency })
            }
            switch (this.locale) {
                case "uk":
                    return `Оплата буде зроблена в ${this.defaultCurrency}, точна сума списання визначається курсом платіжної системи на момент оплати`
                case "ru":
                    return `Оплата будет произведена в ${this.defaultCurrency}, точная сумма списания определяется курсом платежной системы на момент оплаты`
                case "fr":
                    return `Le paiement sera effectué en ${this.defaultCurrency}, le montant exact débité sera déterminé par le taux de change du système de paiement au moment du paiement`
                default:
                    return `Payment will be made in ${this.defaultCurrency}, the exact amount of withdrawal is determined by the rate of the payment system at the time of payment`
            }
        }
    }
}
</script>

<style lang="sass">
@import "resources/sass/vars"

.summary-converted-container
    left: 100%
    bottom: 5px

.summary-converted-price
    font-weight: 400
    color: $text-accent-color
    white-space: nowrap

.relative-converted
    position: relative
    left: 0

b
    font-weight: 700
    color: #52565C
</style>
